import React from "react";
import { createRoot } from "react-dom/client";
import GamerideSite from "./gameride-site.jsx";

class ErrorBoundary extends React.Component {
  constructor(p){ super(p); this.state={err:null}; }
  static getDerivedStateFromError(err){ return {err}; }
  componentDidCatch(err, info){ console.error("[Gameride crash]", err, info); }
  render(){
    if(!this.state.err) return this.props.children;
    return (
      <div style={{minHeight:"100vh",background:"#060c06",color:"#c8e8c8",fontFamily:"monospace",padding:40,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16,textAlign:"center"}}>
        <div style={{fontSize:40}}>💥</div>
        <div style={{color:"#4EFF9A",fontSize:18,letterSpacing:2}}>{'// crash.log'}</div>
        <div style={{color:"#6a9a7a",maxWidth:480,lineHeight:1.5}}>Something went sideways in the sim. Reload the page to try again. If it keeps crashing, check the browser console.</div>
        <button onClick={()=>window.location.reload()} style={{fontFamily:"'Press Start 2P',monospace",background:"#4EFF9A",color:"#060c06",border:"none",padding:"12px 22px",cursor:"pointer",fontSize:13,letterSpacing:2,clipPath:"polygon(4px 0%,calc(100% - 4px) 0%,100% 4px,100% calc(100% - 4px),calc(100% - 4px) 100%,4px 100%,0% calc(100% - 4px),0% 4px)"}}>RELOAD</button>
      </div>
    );
  }
}

const root = createRoot(document.getElementById("root"));
root.render(<ErrorBoundary><GamerideSite /></ErrorBoundary>);
